export const BASE_URL = "https://api.softmri.com/api";
